<template>
  <v-card outline>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <v-card outlined>
        <v-data-table
          :headers="chargesHeaders"
          :items="charges"
          :items-per-page="-1"
          hide-default-footer
        >
          <template v-slot:item.adjustment="{ item }">
            <v-text-field
              type="number"
              v-model="chargesData[item.occupancy].adjustment"
              min="0"
              class="pt-1 ma-0 short-input"
              @change="onChargesDataChange('adjustment', item.occupancy)"
            ></v-text-field>
          </template>
          <template v-slot:item.percent="{ item }">
            <v-text-field
              type="number"
              v-model="chargesData[item.occupancy].percent"
              min="0"
              class="pt-1 ma-0 short-input"
              @change="onChargesDataChange('percent', item.occupancy)"
            ></v-text-field>
          </template>
          <template v-slot:item.foc="{ item }">
            <v-text-field
              type="number"
              v-model="chargesData[item.occupancy].foc"
              min="0"
              class="pt-1 ma-0 short-input"
              @change="onChargesDataChange('occupancy', item.occupancy)"
            ></v-text-field>
          </template>
          <template v-slot:item.pp="{ item }">
            {{ Number(item.pp).toFixed(2) }}
          </template>
          <template v-slot:item.total="{ item }">
            {{ Number(item.total).toFixed(2) }}
          </template>
        </v-data-table>
        <v-row justify="center">
          <span
            >Total FOC Value:
            <strong>{{ totalFocValue.toFixed(2) }}</strong></span
          >
        </v-row>
      </v-card>
      <v-container>
        <v-row justify="center">
          <v-btn text color="primary" @click="onCreateItinerary">{{
            forItinerary ? "Update Itinerary" : "Create Itinerary"
          }}</v-btn>
        </v-row>
      </v-container>
      <v-container fluid px-0>
        <v-expansion-panels>
          <v-expansion-panel class="elevation-2">
            <v-expansion-panel-header>
              Services Breakdown
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <h5>Other Services:</h5>
              <v-container>
                <v-card outlined>
                  <v-data-table
                    :headers="otherHeaders"
                    :items="otherServices"
                    :items-per-page="-1"
                    hide-default-footer
                  >
                    <template v-slot:item.pp="{ item }">
                      <v-tooltip right max-width="300">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon color="grey lighten-1"
                              >mdi-information</v-icon
                            >
                          </v-btn>
                        </template>
                        <v-data-table
                          :headers="otherBreakdownHeaders"
                          :items="item.breakdown"
                          :items-per-page="-1"
                          hide-default-footer
                        >
                          <template v-slot:item.pp="{ item }">{{
                            item.pp.toFixed(2)
                          }}</template></v-data-table
                        >
                      </v-tooltip>
                      {{ item.pp.toFixed(2) }}
                    </template>
                  </v-data-table>

                  <v-row justify="center">
                    <span
                      >Total:
                      <strong>{{ totalOtherServices.toFixed(2) }}</strong></span
                    >
                  </v-row>
                </v-card>
              </v-container>
              <h5>Accommodation:</h5>
              <v-container>
                <v-card outlined>
                  <v-data-table
                    :headers="accommodationsHeaders"
                    :items="accommodations"
                    :items-per-page="-1"
                    hide-default-footer
                  >
                  </v-data-table>
                </v-card>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
      <div v-if="debug">
        <code>{{ items }}</code>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { removeGQLTypename, sortBy } from "../../../../../helpers";
import { ALL_RATE_TYPES_SEARCH_QUERY } from "../../../../../constants/graphql";
export default {
  name: "pax-pricing",
  props: {
    paxFrom: {
      type: Number,
      default: () => 1,
    },
    paxTo: {
      type: Number,
      default: () => 2,
    },
    items: {
      type: Array,
      default: () => [],
    },
    accommodations: {
      type: Array,
      default: () => [],
    },
    adjustment: {
      type: Object,
      default: () => null,
    },
    forItinerary: {
      type: Boolean,
      default: () => false,
    },
    paxType: {
      type: String,
      default: () => "",
    },
  },

  data() {
    return {
      debug: false,
      accommodationsHeaders: [
        {
          text: "Room Type",
          value: "name",
          name: "name",
        },
        {
          text: "PP",
          value: "pp",
          name: "pp",
        },
      ],
      chargesHeaders: [
        {
          text: "Charges",
          value: "name",
          name: "name",
        },
        {
          text: "PP",
          value: "pp",
          name: "pp",
        },
        {
          text: "FOC",
          value: "foc",
          name: "foc",
        },
        {
          text: "Adjust",
          value: "adjustment",
          name: "adjustment",
        },
        {
          text: "%",
          value: "percent",
          name: "percent",
        },
        {
          text: "Total",
          value: "total",
          name: "total",
        },
      ],
      otherHeaders: [
        {
          text: "Service Name",
          value: "name",
          name: "name",
        },
        {
          text: "PP",
          value: "pp",
          name: "pp",
        },
      ],
      otherBreakdownHeaders: [
        {
          text: "Pax",
          value: "pax",
          name: "pax",
        },
        {
          text: "Qty",
          value: "qty",
          name: "qty",
        },
        {
          text: "PP",
          value: "pp",
          name: "pp",
        },
      ],
      chargesData: {
        1: {
          adjustment: this.adjustment ? this.getAdjustment(1) : 0,
          foc: this.adjustment ? this.getFoc(1) : 0,
          percent: null,
        },
        2: {
          adjustment: this.adjustment ? this.getAdjustment(2) : 0,
          foc: this.adjustment ? this.getFoc(2) : 0,
          percent: null,
        },
        3: {
          adjustment: this.adjustment ? this.getAdjustment(3) : 0,
          foc: this.adjustment ? this.getFoc(3) : 0,
          percent: null,
        },
        4: {
          adjustment: this.adjustment ? this.getAdjustment(4) : 0,
          foc: this.adjustment ? this.getFoc(4) : 0,
          percent: null,
        },
        100: {
          adjustment: this.adjustment ? this.getAdjustment(100) : 0,
          foc: this.adjustment ? this.getFoc(100) : 0,
          percent: null,
        },
        200: {
          adjustment: this.adjustment ? this.getAdjustment(200) : 0,
          foc: this.adjustment ? this.getFoc(200) : 0,
          percent: null,
        },
      },
    };
  },

  computed: {
    charges() {
      return this.accommodations.map((a) => ({
        name: a.name,
        pp: a.pp + this.totalOtherServices,
        adjustment: this.chargesData[a.occupancy].adjustment,
        foc: this.chargesData[a.occupancy].foc,
        total:
          Number(a.pp) +
          Number(this.totalOtherServices) +
          Number(this.totalFocValue) +
          Number(this.chargesData[a.occupancy].adjustment),
        occupancy: a.occupancy,
        percent: this.chargesData[a.occupancy].percent,
      }));
    },
    totalFocValue() {
      return this.accommodations.reduce(
        (sum, a) =>
          sum +
          ((Number(a.pp) + Number(this.totalOtherServices)) *
            Number(this.chargesData[a.occupancy].foc)) /
            (Number(this.paxFrom) - Number(this.chargesData[a.occupancy].foc)),
        0
      );
    },
    totalOtherServices() {
      return this.otherServices.reduce((sum, item) => sum + Number(item.pp), 0);
    },
    otherServices() {
      return this.items
        .filter((item) => item.serviceTypeName != "ACCOMMODATION")
        .map((item) => {
          const breakdown = [];
          const rateType = this.rateTypes
            ? this.rateTypes.edges
                .map(removeGQLTypename)
                .find((r) => r.code == item.rateType)
            : null;
          for (let i = this.paxFrom; i <= this.paxTo; i++) {
            const qty = Math.ceil(i / Number(item.stdOccupancy));
            breakdown.push({
              pax: i,
              qty,
              pp:
                rateType && rateType.includePax
                  ? Number(item.price)
                  : (qty * Number(item.price)) / i,
            });
          }
          return {
            name: `${item.serviceName}`,
            breakdown,
            pp: breakdown.sort(sortBy("pp"))[breakdown.length - 1]["pp"],
          };
        });
    },
    title() {
      return `Pax From: ${this.paxFrom}, Pax To: ${this.paxTo}`;
    },
  },

  watch: {
    charges(newVal) {
      for (let i = 1; i <= 4; i++) {
        if (!this.chargesData[i].percent) {
          const charge = this.charges.find((c) => c.occupancy == i);
          if (charge && charge.adjustment) {
            this.chargesData[i].percent = (
              (charge.adjustment / charge.pp) *
              100
            ).toFixed(2);
          }
        }
      }
    },
  },

  methods: {
    onCreateItinerary() {
      this.$emit("create-itinerary", {
        charges: [...this.charges],
        paxFrom: this.paxFrom,
        paxTo: this.paxTo,
      });
    },
    onChargesDataChange(f, i) {
      if (f == "percent") {
        //update adjustment
        const percent = Number(this.chargesData[i].percent) / 100;
        const ppForCharge = this.charges.find((c) => c.occupancy == i).pp;
        this.chargesData[i].adjustment = (
          Number(ppForCharge) * percent
        ).toFixed(2);
      } else if (f == "adjustment") {
        const adjustment = Number(this.chargesData[i].adjustment);
        const ppForCharge = this.charges.find((c) => c.occupancy == i).pp;
        this.chargesData[i].percent = (
          (adjustment / ppForCharge) *
          100
        ).toFixed(2);
      }
      this.$emit("change", {
        paxFrom: this.paxFrom,
        paxTo: this.paxTo,
        adjustment1:
          this.paxType == "adults"
            ? Number(this.chargesData[1].adjustment)
            : this.adjustment.adjustment1,
        adjustment2:
          this.paxType == "adults"
            ? Number(this.chargesData[2].adjustment)
            : this.adjustment.adjustment2,
        adjustment3:
          this.paxType == "adults"
            ? Number(this.chargesData[3].adjustment)
            : this.adjustment.adjustment3,
        adjustment4:
          this.paxType == "adults"
            ? Number(this.chargesData[4].adjustment)
            : this.adjustment.adjustment4,
        foc1:
          this.paxType == "adults"
            ? Number(this.chargesData[1].foc)
            : this.adjustment.foc1,
        foc2:
          this.paxType == "adults"
            ? Number(this.chargesData[2].foc)
            : this.adjustment.foc2,
        foc3:
          this.paxType == "adults"
            ? Number(this.chargesData[3].foc)
            : this.adjustment.foc3,
        foc4:
          this.paxType == "adults"
            ? Number(this.chargesData[4].foc)
            : this.adjustment.foc4,
        childAdjustment1:
          this.paxType == "children"
            ? Number(this.chargesData[1].adjustment)
            : this.adjustment.childAdjustment1,
        childAdjustment2:
          this.paxType == "children"
            ? Number(this.chargesData[2].adjustment)
            : this.adjustment.childAdjustment2,
        childAdjustment3:
          this.paxType == "children"
            ? Number(this.chargesData[3].adjustment)
            : this.adjustment.childAdjustment3,
        childAdjustment4:
          this.paxType == "children"
            ? Number(this.chargesData[4].adjustment)
            : this.adjustment.childAdjustment4,
        childFoc1:
          this.paxType == "children"
            ? Number(this.chargesData[1].foc)
            : this.adjustment.childFoc1,
        childFoc2:
          this.paxType == "children"
            ? Number(this.chargesData[2].foc)
            : this.adjustment.childFoc2,
        childFoc3:
          this.paxType == "children"
            ? Number(this.chargesData[3].foc)
            : this.adjustment.childFoc3,
        childFoc4:
          this.paxType == "children"
            ? Number(this.chargesData[4].foc)
            : this.adjustment.childFoc4,
        infantAdjustment1:
          this.paxType == "infants"
            ? Number(this.chargesData[1].adjustment)
            : this.adjustment.infantAdjustment1,
        infantAdjustment2:
          this.paxType == "infants"
            ? Number(this.chargesData[2].adjustment)
            : this.adjustment.infantAdjustment2,
        infantAdjustment3:
          this.paxType == "infants"
            ? Number(this.chargesData[3].adjustment)
            : this.adjustment.infantAdjustment3,
        infantAdjustment4:
          this.paxType == "infants"
            ? Number(this.chargesData[4].adjustment)
            : this.adjustment.infantAdjustment4,
        infantFoc1:
          this.paxType == "infants"
            ? Number(this.chargesData[1].foc)
            : this.adjustment.infantFoc1,
        infantFoc2:
          this.paxType == "infants"
            ? Number(this.chargesData[2].foc)
            : this.adjustment.infantFoc2,
        infantFoc3:
          this.paxType == "infants"
            ? Number(this.chargesData[3].foc)
            : this.adjustment.infantFoc3,
        infantFoc4:
          this.paxType == "infants"
            ? Number(this.chargesData[4].foc)
            : this.adjustment.infantFoc4,
      });
    },
    getAdjustment(no) {
      const paxMap = {
        adults: "adjustment",
        children: "childAdjustment",
        infants: "infantAdjustment",
      };
      const f = paxMap[this.paxType];
      return this.adjustment[`${f}${no}`];
    },
    getFoc(no) {
      const paxMap = {
        adults: "foc",
        children: "childFoc",
        infants: "infantFoc",
      };
      const f = paxMap[this.paxType];
      return this.adjustment[`${f}${no}`];
    },
  },

  apollo: {
    rateTypes: {
      query: ALL_RATE_TYPES_SEARCH_QUERY,
    },
  },
};
</script>

<style scoped>
.short-input {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/increments/PaxPricing.vue